import styled from "styled-components";
import { CircleButton } from "@sonder/ui/source/styled/fragments/CircleButton";
import { colors } from "@sonder/ui/source/styled/theme";

export const Toast = styled.div`
  align-items: center;
  background: ${colors.blue2};
  border-left: 1rem solid ${colors.yellow};
  border-radius: 0.3rem;
  box-shadow: ${colors.shadow};
  box-sizing: border-box;
  color: ${colors.white};
  display: flex;
  justify-content: space-between;
  min-height: 5.25rem;
  min-width: 27rem;
  padding: 1rem;

  > svg {
    flex-shrink: 0;
    height: 1.8rem;
    width: 1.8rem;
  }
  > button {
    flex-shrink: 0;
  }
  > ${CircleButton} {
    margin-left: 0.75rem;
  }
`;
